import * as React from 'react';

import { computeText } from '@/locales/utils';
import { Input } from '@/components/form/Input';
import { FormattedMessage, useIntl } from 'react-intl';
import { Text } from '@/components/atoms/Text';
import { SvyButton } from '@/components/savory/SvyButton';
import { confirm } from '@/core/asyncActions/confirm';
import { useUnarchiveCustomerMutation } from '@/services/innovorder/adminTools/adminTools.endpoints';
import { FormControl, FormControls, SuccessMessage } from '../AdminTools.style';
import { safeMutate } from '@/utils/errors';
import { Form } from '@/core/form/Form';

export type UnarchiveCustomerInputs = {
    customerId: string;
};

const UnarchiveCustomer: React.FunctionComponent = () => {
    const intl = useIntl();

    const [unarchiveCustomer, { isSuccess }] = useUnarchiveCustomerMutation();

    const handleSubmitForm = async ({ customerId }: UnarchiveCustomerInputs) => {
        const hasConfirmed = await confirm(computeText(intl, 'adminTools.confirmModal.description'));
        if (hasConfirmed) {
            await safeMutate(
                unarchiveCustomer({
                    customerId,
                }),
            );
        }
    };

    return (
        <Form<UnarchiveCustomerInputs>>
            {({ handleSubmit }) => {
                return (
                    <>
                        <Text type="large" text="brand.adminTools.unarchiveCustomer.title" />
                        <FormControls>
                            <FormControl>
                                <Input
                                    name="customerId"
                                    rules={{ required: computeText(intl, 'field.required') }}
                                    placeholder="brand.adminTools.unarchiveCustomer.form.placeholder.customerId"
                                    labelId="brand.adminTools.unarchiveCustomer.form.customerId"
                                />
                            </FormControl>
                            <SvyButton onClick={handleSubmit(handleSubmitForm)}>
                                <FormattedMessage id="button.validate" />
                            </SvyButton>
                            {isSuccess && <SuccessMessage text="brand.adminTools.unarchiveCustomer.form.success" />}
                        </FormControls>
                    </>
                );
            }}
        </Form>
    );
};

export default UnarchiveCustomer;
